/**
 * SSO pro Virtus Lead B2B (prospecção e pipeline B2B).
 *
 * O Lead B2B autentica pelo SMM: a rota /auth/callback dele aceita o access_token do SMM em
 * `sso_token` e abre a sessão com ele. Então o SSO aqui é só repassar o token atual.
 */
const LEAD_B2B_BASE_URL = (
  (import.meta.env.VITE_LEAD_B2B_URL as string | undefined) ||
  "https://b2b.virtusautomation.com"
).replace(/\/$/, "");

/** URL de entrada com SSO (ou a home, sem sessão no SMM). Usada também pela rota /launch. */
export function getLeadB2bSsoUrl(): string {
  const token = localStorage.getItem("access_token");
  if (!token) return LEAD_B2B_BASE_URL;
  return `${LEAD_B2B_BASE_URL}/auth/callback?sso_token=${encodeURIComponent(token)}`;
}

export function openLeadB2bSSO(): void {
  window.open(getLeadB2bSsoUrl(), "_blank", "noopener,noreferrer");
}
